var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mask_contents-wrap with_floting st_type02" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "list_mask" }, [
        _c("div", { staticClass: "reservation_product" }, [
          _c("div", { staticClass: "choice-area" }, [
            _c("span", { staticClass: "form_element-radio no_label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.qty,
                    expression: "qty"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "choice1",
                  name: "choice",
                  value: "qty1"
                },
                domProps: { checked: _vm._q(_vm.qty, "qty1") },
                on: {
                  change: function($event) {
                    _vm.qty = "qty1"
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "sp_chk focus", attrs: { for: "choice1" } },
                [_vm._v("선택")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_img" }, [
            _c("img", {
              attrs: { src: require("./images/mask_small.jpg"), alt: "" },
              on: {
                click: function($event) {
                  _vm.qty = "qty1"
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_data" }, [
            _c("p", { staticClass: "product_name" }, [
              _vm._v("메타에어 비말차단용 마스크\n            KF-AD(대형) 30매")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "product_sku" }, [
              _vm._v("SKU : " + _vm._s(_vm.sku1))
            ]),
            _vm._v(" "),
            _vm._m(2)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reservation_product" }, [
          _c("div", { staticClass: "choice-area" }, [
            _c("span", { staticClass: "form_element-radio no_label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.qty,
                    expression: "qty"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "choice2",
                  name: "choice",
                  value: "qty2"
                },
                domProps: { checked: _vm._q(_vm.qty, "qty2") },
                on: {
                  change: function($event) {
                    _vm.qty = "qty2"
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "sp_chk focus", attrs: { for: "choice2" } },
                [_vm._v("선택")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_img" }, [
            _c("img", {
              attrs: { src: require("./images/mask_small.jpg"), alt: "" },
              on: {
                click: function($event) {
                  _vm.qty = "qty2"
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_data" }, [
            _c("p", { staticClass: "product_name" }, [
              _vm._v("엠케어마스크\n            KF-AD(대형) 30매")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "product_sku" }, [
              _vm._v("SKU : " + _vm._s(_vm.sku2))
            ]),
            _vm._v(" "),
            _vm._m(3)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reservation_product" }, [
          _c("div", { staticClass: "choice-area" }, [
            _c("span", { staticClass: "form_element-radio no_label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.qty,
                    expression: "qty"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "choice3",
                  name: "choice",
                  value: "qty3"
                },
                domProps: { checked: _vm._q(_vm.qty, "qty3") },
                on: {
                  change: function($event) {
                    _vm.qty = "qty3"
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "sp_chk focus", attrs: { for: "choice3" } },
                [_vm._v("선택")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_img" }, [
            _c("img", {
              attrs: { src: require("./images/mask_small.jpg"), alt: "" },
              on: {
                click: function($event) {
                  _vm.qty = "qty3"
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_data" }, [
            _c("p", { staticClass: "product_name" }, [
              _vm._v("엠케어마스크\n            KF-AD(소형) 30매")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "product_sku" }, [
              _vm._v("SKU :  " + _vm._s(_vm.sku3))
            ]),
            _vm._v(" "),
            _vm._m(4)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reservation-area" }, [
        _c("h2", { staticClass: "title_type-b" }, [_vm._v("예약자 정보 입력")]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "new-join-wrap" }, [
            _c("div", { staticClass: "ipt_area" }, [
              _c(
                "label",
                { staticClass: "form_label", attrs: { for: "ko_num" } },
                [_vm._v("ABO 번호")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search_abo,
                    expression: "search_abo"
                  },
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "###########",
                    expression: "'###########'"
                  }
                ],
                staticClass: "form_ipt",
                attrs: { type: "tel", id: "ko_abo" },
                domProps: { value: _vm.search_abo },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search_abo = $event.target.value
                    },
                    _vm.aboFocus
                  ]
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "btn_area" }, [
              _c(
                "button",
                {
                  staticClass: "btn_type-s",
                  attrs: { type: "button" },
                  on: { click: _vm.validABO }
                },
                [_vm._v("확인")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ipt_msg_area" }, [
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.abo_pass,
                    expression: "abo_pass"
                  }
                ],
                staticClass: "noti-suc pass"
              },
              [_vm._v("정상 확인되었습니다.")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.abo_fail,
                    expression: "abo_fail"
                  }
                ],
                staticClass: "noti-suc fail"
              },
              [_vm._v("일치하는 정보가 없습니다. 확인 후 다시 입력해주세요.")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reservation-link-area" }, [
        _c("h2", { staticClass: "title_type-b" }, [_vm._v("예약링크 공유")]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "link_cont_wrap" }, [
            _c("p", { staticClass: "link_info_share" }, [
              _c("span", { staticClass: "link_info_share_num" }, [
                _vm._v(_vm._s(_vm.sharedCnt) + "회 공유")
              ]),
              _vm._v(" /\n            "),
              _c("span", { staticClass: "link_info_num" }, [_vm._v("10회")])
            ]),
            _vm._v(" "),
            _vm._m(5)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_btn_area" }, [
        _c(
          "button",
          {
            staticClass: "btn-share",
            attrs: { type: "button" },
            on: { click: _vm.kakaoShare }
          },
          [_c("i", { staticClass: "sp_ico" }), _vm._v("카카오로 공유하기")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "title_type-a" }, [
      _vm._v("엣모스피어 스카이 "),
      _c("span", { staticClass: "m_block" }, [
        _vm._v("미세먼지 마스크 KF94 (30매)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mask-limit" }, [
      _vm._v("마스크 공급에 제한이 있어 "),
      _c("span", { staticClass: "m_block" }, [
        _vm._v("대형과 소형 중 1개만 예약 가능합니다.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "product_price" }, [
      _c("span", { staticClass: "product_value" }, [_vm._v("18,000")]),
      _vm._v("원 / "),
      _c("span", { staticClass: "product_value" }, [_vm._v("1")]),
      _vm._v("개")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "product_price" }, [
      _c("span", { staticClass: "product_value" }, [_vm._v("67,000")]),
      _vm._v("원 / "),
      _c("span", { staticClass: "product_value" }, [_vm._v("1")]),
      _vm._v("개")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "product_price" }, [
      _c("span", { staticClass: "product_value" }, [_vm._v("67,000")]),
      _vm._v("원 / "),
      _c("span", { staticClass: "product_value" }, [_vm._v("1")]),
      _vm._v("개")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "link_info_txt" }, [
      _vm._v("*ABO당 "),
      _c("span", { staticClass: "link_info_share_num" }, [_vm._v("총 10회")]),
      _vm._v(" 공유하실 수 있습니다.")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12ae4b3b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ae4b3b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/atmosphere-mask/reserv.vue
// module id = null
// module chunks = 